module.exports = __webpack_public_path__ + "static/media/mv.a57f9112.png";